import { createSlice } from '@reduxjs/toolkit';
import { initMediaQueryData } from '../utils';
import containerQuery from '../constants/containerQuery';

const initialState = initMediaQueryData(containerQuery);

export const updateMatchMediaFunc = (state, action) => ({ ...state, ...action.payload });

const matchMediaSlice = createSlice({
  name: 'matchMedia',
  initialState,
  reducers: {
    updateMatchMedia: updateMatchMediaFunc,
  },
});

export const { updateMatchMedia } = matchMediaSlice.actions;

export default matchMediaSlice.reducer;
